import { Trans } from '@lingui/react'
import { bool } from 'prop-types'

import Modal from 'views/components/molecules/Modal'
import RedPointsInformationModalContent from 'views/components/organisms/Checkout/RedPointsInformationModalContent'

import { RED_POINTS_INFORMATION_MODAL } from './names'

const RedPointsInformationModal = ({ open }) => {
  return (
    <Modal
      size="medium"
      id={RED_POINTS_INFORMATION_MODAL}
      title={<Trans id="general.label.redPoints" />}
      isClientSideControlled
      open={open}
    >
      <RedPointsInformationModalContent />
    </Modal>
  )
}

RedPointsInformationModal.propTypes = {
  open: bool,
}

RedPointsInformationModal.defaultProps = {
  open: false,
}

export default RedPointsInformationModal
